import { ICustomHolidayView } from '@/class/models/typed/custom-holiday';
import {
  LaborCalendarEventKind,
  ILaborCalendarEvent,
} from '@/class/models/typed/labor';
import { CalEvent } from '@/class/models/views/labor';

/**
 * カレンダー表示用の祝日イベントに変換
 */
export function toHolidayEvents(hs: ICustomHolidayView[]): CalEvent[] {
  return hs.map((h) => {
    return {
      id: `holiday-${h.customHolidayID}`,
      workContent: `${h.name}`,
      start: h.date,
      kind: LaborCalendarEventKind.HOLIDAY_FULL,
      everyYear: h.everyYear,
      isCustomHoliday: true,
    };
  });
}

/**
 * カレンダー表示用のイベントに変換
 */
export function toCalEvents(rows: ILaborCalendarEvent[]): CalEvent[] {
  return rows.map((r) => {
    const isWork = r.kind === LaborCalendarEventKind.WORK;

    const workContent = isWork ? `${r.startTime} ${r.description}` : undefined;

    const color = isWork ? undefined : '#ffe9ee';

    return {
      id: r.id,
      kind: r.kind,
      workContent,
      start: r.startYmd,
      end: r.endYmd,
      startTime: r.startTime,
      color,
      absenceType: r.absenceType,
      specialLeaveName: r.specialLeaveName,
      paidLeaveType: r.paidLeaveType,
    };
  });
}
